export default __webpack_public_path__ + "static/media/no-assessments.57ad6185.svg";